<template>
  <nav class="navbar navbar-header navbar-expand-lg" data-background-color="white">
    <div class="container-fluid">
      <ul class="navbar-nav topbar-nav ml-md-auto align-items-center">
        <li class="nav-item">
          <a class="nav-link btn-lg" href="https://help.indiefy.net/knowledge" target="_blank">
            <i class="far fa-question-circle"></i>
          </a>
        </li>
        <li class="nav-item dropdown hidden-caret submenu">
          <a class="nav-link dropdown-toggle btn-lg" href="#" id="messageDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-language"></i>
          </a>
          <ul class="dropdown-menu animated fadeIn" aria-labelledby="messageDropdown">
            <li>
              <a :href="`/?lang=en`" class="dropdown-item">
                English
              </a>
            </li>
            <li>
              <a :href="`/?lang=es`" class="dropdown-item">
                Español
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'NavigationBar',
  data: function () {
    return {
      searching: false,
      term: '',
      user: null,
      notifications: [],
      defaultImage: '/static/img/img-placeholder.jpg'
    }
  },
  methods: {
    search: function () {
      if (!this.term || this.term.length < 3) {
        return this.$notify({ message: this.$t('search_term_short') }, 'warning', 'fa-exclamation')
      }

      this.searching = true
      this.$router.push(`/search?q=${this.term}`)
    }
  },
  watch: {
    term: _.debounce(function (value) {
      if (value && value.length >= 3) {
        this.search()
      }
    }, 500)
  },
  created: function () {
    this.user = this.$user

    // Notifications.getAll().then(response => {
    //   this.notifications = response.data.splice(0, 3)

    //   _.each(this.notifications, notification => {
    //     notification.content = window.$(`<span>${notification.content}</span>`).text()
    //   })
    // })

    this.$eventBus.$on('endSearch', () => {
      setTimeout(() => {
        this.searching = false
        this.$forceUpdate()
      }, 10)
    })
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue